class JciBundler extends HTMLElement {

  static get observedAttributes() {
    // use kebab-case in HTML: <jci-bundler section-id="..." country="AU"></jci-bundler>
    return ["data-current"];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue === newValue) return;
    if(name=="data-current" && (newValue==true || newValue=="true")){
      console.log('attributeChangedCallback ' +name, oldValue, newValue)
      this.init();
    }
  }


  connectedCallback() {

  }

  init() {
    const self = this;
    const swipers = new Map();


    jQuery(function ($) {
      initBundler($);
    });

    function $q(selector) {
      return $(self).find(selector);
    }

    function initBundler($) {
      if ($q('.bundle-button').length) {
        $q('.bundle-button').on('click', function () {
          const bundleKey = $(this).data('bundle-key');
          const bundleGender = $q('.jci-bundle-tabs .bundle-tab.active').attr('data-tab');
          window.location.href = `?bundle=${bundleKey}&gender=${bundleGender}`;
        });
      }

      const selector = $q('.jci-bundle-selector');
      if (!selector.length) return;

      const reqA = parseInt(selector.data('requiredGroupA'), 10);
      const reqB = parseInt(selector.data('requiredGroupB'), 10);
      const reqC = parseInt(selector.data('requiredGroupC'), 10);

      function requiredFor(tab) {
        return tab === 'group-a' ? reqA
             : tab === 'group-b' ? reqB
             : tab === 'group-c' ? reqC
             : 0;
      }

      let currentTabEl = $q('.jci-bundle-tab.active');
      let currentTab   = currentTabEl.data('tab');
      let currentReq   = requiredFor(currentTab);
      let currentProd  = null;
      let currentPrice = 0;
      const selectedItems = {};

      $q('.jci-bb-required').text(currentReq);
      $q('.jci-bb-product-type').text($q('.jci-bundle-tab.active').text());

      async function getCart() {
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const res = await fetch(`${root}cart.js`, {
          method: 'GET',
          headers: { Accept: 'application/json' }
        });
        if (!res.ok) throw new Error(`Cart fetch failed: ${res.status}`);
        return res.json();
      }

      function updateIndicator(count) {
        const $ind = $q('.jci-bundle-indicator').empty();
        for (let i = 1; i <= currentReq; i++) {
          $ind.append(
            $('<span>')
              .addClass('indicator-circle')
              .toggleClass('filled', i <= count)
          );
        }
      }

      function renderSelectedList() {
        const $list = $q('.jci-selected-list').empty();
        Object.keys(selectedItems).forEach((k) => {
          let cT = selectedItems[k];
          cT?.items?.forEach((it, i) => {
            $list.append(`
              <div class="selected-item" data-index="${i}" data-item-tab="${k}">
                <img src="${it.image}" />
                <button class="remove-item" data-item-tab="${k}">×</button>
              </div>
            `);

            const $tmp = selector.find(`.jci-bundle-item[data-product-handle="${it.handle}"]`)[0];
            setTimeout(() => {
              $tmp?.classList?.add('selected');
            }, 10);
          });
        });
      }

      function allTabsComplete() {
        const tabs = ['group-a', 'group-b', 'group-c'];
        for (const tab of tabs) {
          const req = requiredFor(tab);
          if (selector.find(`.${tab}-grid`).length === 0) continue;
          const items = selectedItems[tab]?.items?.length || 0;
          if (items !== req) return false;
        }
        if (!$q('input[name="is_all_selected"]').prop('checked')) {
          return false;
        }
        return true;
      }

      function refreshUI() {
        const count = selectedItems[currentTab]?.items?.length ?? 0;
        $q('.jci-bb-counter').text(count);
        updateIndicator(count);

        console.log(selectedItems[currentTab]?.items, requiredFor(currentTab));
        if (count == requiredFor(currentTab)) {
          $q('.jci-bb-confirm-button').html('Go to next step');
        } else {
          $q('.jci-bb-confirm-button').html('Confirm Selection');
        }

        const isFull = allTabsComplete();
        $q('.jci-bb-confirm-button').toggle(!isFull);
        $q('.jci-proceed-checkout').toggle(isFull);
        updateSavings();
        updateTotalPrice();
        setTimeout(() => {
          updateSlider();
        }, 100);

        $q('.jci-sizing-chart-wrapper button[data-drawer-opener]').attr(
          'data-drawer-opener',
          `SizeChart-${currentProd?.id}`
        );
      }

      function updateSlider() {
        swipers.forEach(sw => sw.update());
      }

      function updateSavings() {
        const totalRRR = updateTotalPrice();
        const totalDiscountPrice = updateOfferPrice();
        const totalSavings = (parseFloat(totalRRR ?? 0) - parseFloat(totalDiscountPrice ?? 0));
        $q('.savings-wrapper span').html(`${Shopify.formatMoney(totalSavings)}`);
      }

      function updateOfferPrice() {
        console.log('selectedItems', selectedItems);
        const total = Object.values(selectedItems)?.reduce((sum, it) => {
          return it.items?.length > 0 ? sum + parseFloat(it.bundlePrice ?? 0) : sum;
        }, 0) * 100 ?? 0;
        $q('.offer-price > span').html(`${Shopify.formatMoney(total)}`);
        return total;
      }

      $q('.jci-bundle-tab').off('click').on('click', function () {
        const $tabs        = $q('.jci-bundle-tab');
        const clickedIndex = $tabs.index($(this));
        const currentIndex = $tabs.index(currentTabEl);

        const nextTab        = $(this).text();
        const currentTabText = currentTabEl.text();
        const currentItems   = selectedItems[currentTab]?.items?.length || 0;

        if (clickedIndex > currentIndex) {
          if (currentItems !== currentReq) {
            alert(`Please complete the required ${currentReq} selections in ${currentTabText.toUpperCase()} before moving to ${nextTab.toUpperCase()}.`);
            return;
          }
        }

        currentTabEl = $(this);
        currentTab   = $(this).data('tab');
        currentReq   = requiredFor(currentTab);
        $q('.jci-bb-required').text(currentReq);
        $q('.jci-bb-product-type').text($(this).text());

        $q('.jci-bundle-tab, .jci-bundle-grid.active').removeClass('active');
        $(this).addClass('active');
        $q('.' + currentTab + '-grid').addClass('active');

        renderSelectedList();
        selector.find('.jci-bundle-item.selected, .jci-temp-active')
                .removeClass('selected jci-temp-active');

        const first = $q(`.${currentTab}-grid .jci-bundle-item`).first();
        selector.find('.jci-temp-active').removeClass('jci-temp-active');
        first.addClass('jci-temp-active');

        if (first.length) {
          loadBundleDetail(first.data('product-handle'));
        }

        refreshUI();
        updateOfferPrice();
      });

      selector.on('click', '.jci-bundle-item', function () {
        const $item      = $(this);
        const key        = currentTab.split('-')[1];
        const bundlePrice = parseFloat(selector.data(`price-${key}`));

        selectedItems[currentTab] = {
          bundlePrice: bundlePrice,
          is_bundle: true,
          items: [],
        };

        selector.find('.jci-bundle-item.selected').removeClass('selected');
        selector.find('.jci-temp-active').removeClass('jci-temp-active');
        $item.addClass('jci-temp-active');
        loadBundleDetail($item.data('product-handle'));
        refreshUI();
      });

      $q('.jci-bb-confirm-button').off('click').on('click', function () {
        $q('.bundle-detail-size-error').html('');
        if (currentTabEl.next('.jci-bundle-tab').length == 0) {
          $q('input[name="is_all_selected"]').prop('checked', true);
        }
        if ($(this).text() == 'Go to next step') {
          let nextTabEl = currentTabEl.next('.jci-bundle-tab');
          refreshUI();
          return nextTabEl.click();
        }

        if (selectedItems[currentTab]?.items?.length >= currentReq) return;

        const key         = currentTab.split('-')[1];
        const bundlePrice = parseFloat(selector.data(`price-${key}`));

        if (!selectedItems[currentTab]) {
          selectedItems[currentTab] = {
            bundlePrice: bundlePrice,
            is_bundle: true,
            items: [],
          };
        }

        const $tmp = selector.find('.jci-temp-active');
        if (!$tmp.length) return;

        const size = $q('#bundle-detail-size-pickers input[name="bundle-size"]:checked').val();
        if (!size) {
          $q('.bundle-detail-size-error').html('Please select size!');
          return;
        }
        const variant = currentProd.variants.find(v => v.option1 === size) || currentProd.variants[0];
        selectedItems[currentTab]?.items?.push({
          handle:    currentProd.handle,
          size,
          variant_id: variant.id,
          image:     $tmp.find('img').attr('src'),
          price:     currentPrice,
          properties: { _kit_builder_title: self.dataset.offerTitle, _has_bundle_discount: true },
        });

        updateOfferPrice();
        updateTotalPrice();

        $tmp.removeClass('jci-temp-active').addClass('selected');
        renderSelectedList();
        refreshUI();
      });

      $q('.jci-selected-list').on('click', '.selected-item', function () {
        const idx    = $(this).closest('.selected-item').data('index');
        const rmTab  = $(this).attr('data-item-tab');
        const removed = selectedItems[rmTab]?.items?.splice(idx, 1)[0];
        selector
          .find(`.jci-bundle-item[data-product-handle="${removed.handle}"]`)
          .removeClass('selected');

        setTimeout(() => {
          $q(`.jci-bundle-tab[data-tab="${rmTab}"]`).click();
        }, 500);

        renderSelectedList();
        refreshUI();
      });

      function updateTotalPrice() {
        try {
          console.log('updateTotalPrice', selectedItems)
          const total = Object.values(selectedItems)?.reduce((sum, it) => {
            let subSum = it?.items.reduce((its, ita) => its + parseFloat(ita.price ?? 0), 0);
            return sum + parseFloat(subSum ?? 0);
          }, 0) ?? 0;
          $q('.products-price span').html(`${Shopify.formatMoney(total)}`);
          return total;
        } catch (error) {
          console.error(error);
        }
      }

      function loadBundleDetail(handle) {
        console.log('loadBundleDetail', handle)
        fetch(`/products/${handle}.js`)
          .then(r => r.json())
          .then(prod => {
            currentProd = prod;
        console.log('currentProd', currentProd)

            $q('#bundle-selected-product-link').attr('href', location.origin + prod.url);
            $q('#bundle-selected-product-link h2').text(prod.title);

            let pgReviewEl = selector.find(`.jci-bundle-grid-wrapper .swiper-slide:has(.jci-bundle-item[data-product-id="${currentProd.id}"]) .custom-pg-reviews`);
            $q('.jci-bb-confirm .bundle-prod-review').html(pgReviewEl);
            let bundleShortDesc = selector.find(`.jci-bundle-grid-wrapper .swiper-slide:has(.jci-bundle-item[data-product-id="${currentProd.id}"]) .jci-bundle-item-short-desc`);
            $q('#bundle-selected-product-desc > .desc-content').html(bundleShortDesc.clone(true).removeClass('hide'));

            const priceVar       = prod.variants.find(v => v.available) || prod.variants[0];
            currentPrice         = priceVar.price;
            const formattedPrice = (priceVar.price / 100).toFixed(2);
            $q('.jci-bundle-each-product-price span').text(formattedPrice);

              console.log('prod', prod)


            const opt = prod.options.find(o => o.name.toLowerCase() === 'size');
            if (opt) {
              const html = opt.values.map((v, i) => {
                const prodVariant = prod.variants.find(ant => ant.options?.includes(v));
                const isAvailable = prodVariant?.available;
                return `<input type="radio" ${isAvailable ? '' : 'disabled="disabled"'} id="bundle-size-${self.dataset.blockId}-${i}" name="bundle-size" value="${v}">
                <label for="bundle-size-${self.dataset.blockId}-${i}">${v}</label>`;
              }).join('');
              $q('#bundle-detail-size-pickers').html(html);
              if (opt.values?.length == 1) {
                $q('#bundle-detail-size-pickers').find('input[name="bundle-size"]').first().prop('checked', true);
              }

              $q('.jci-whats-my-size-link')
                .attr('data-drawer-opener', 'SizeChart-' + prod.id)
                .show();
            } else {
              $q('#bundle-detail-size-pickers').empty();
              $q('.jci-whats-my-size-link').hide();
            }
          })
          .catch(console.error);
      }

      const first = selector.find('.jci-bundle-grid.active .jci-bundle-item').first();
      if (first.length) first.click();
      refreshUI();

      $q('.jci-bb-back-button').off('click').on('click', async function () {
        let nextTabEl = currentTabEl.prev('.jci-bundle-tab');
        $q('input[name="is_all_selected"]').prop('checked', false);
        if (nextTabEl.length > 0) {
          $q('.jci-proceed-checkout').attr('force', false);
          return nextTabEl.click();
        } else {
          window.location.href = `/pages/cycology-bundles`;
        }
      });

      $q('.jci-proceed-checkout').off('click').on('click', async function () {
        const $btn    = $(this);
        const $loader = $btn.find('.loader');
        const $text   = $btn.find('.button-text');

        if (window.innerWidth < 749 && !$btn.hasClass('jci-mobile-checkout') && ($(this).attr('force') != true && $(this).attr('force') != 'true')) {
          var scrollToPosition = $q('.jci-proceed-checkout.jci-mobile-checkout').offset().top - window.innerHeight + 200;
          $('html, body').animate({ scrollTop: scrollToPosition }, 1000);
          $(this).attr('force', true);
          //return console.log(scrollToPosition);
        }

        $loader.show();
        $text.text('Processing...');
        $btn.prop('disabled', true);

        try {
          try {
            let getCartItems = await getCart();
            selectedItems['_cart'] = {
              ...{
                token: getCartItems?.token || null
              },
              ...{
                is_bundle: false,
                bundlePrice: 0,
              }
            };
          } catch (error) {
            console.log('no item on cart!');
          }

          const resp = await fetch('https://cycology-endpoint.vercel.app/api/checkout', {
            method:  'POST',
            headers: { 'Content-Type': 'application/json' },
            body:    JSON.stringify({ selectedItems: selectedItems })
          });
          const json = await resp.json();
          if (!resp.ok) throw new Error(json.error || 'Unknown error');
          window.location.href = json.checkoutUrl;
        } catch (err) {
          console.error('Checkout failed:', err);
          alert('Sorry, there was a problem creating your bundle. Please try again.');
          $loader.hide();
          $text.text('Proceed to Checkout');
          $btn.prop('disabled', false);
        }
      });

      // Init Swipers scoped to this component instance
      self.querySelectorAll('.jci-bundle-swiper').forEach(function (el) {
        const s = createSwiper(el);
        swipers.set(el.id || el, s);
      });

      const mq = window.matchMedia('(max-width: 768px)');
      mq.addEventListener('change', () => {
        setTimeout(() => {
          swipers.forEach(sw => sw.update());
        }, 2000);
      });
      if (mq.matches) {
        swipers.forEach(sw => sw.update());
      }

      function checkEllipsis() {
        const $el = $q('#bundle-selected-product-desc');
        if (!$el.length) return;
        const $contentEl = $el.find('.desc-content');
        if (!$contentEl.length) return;
        const cEl = $contentEl[0];
        const isEllipsed = cEl.scrollHeight > cEl.clientHeight;
        $el.toggleClass('has-ellipsis', isEllipsed);
      }

      $(window).on('load resize', checkEllipsis);
    }
  }
}

function createSwiper(el) {
  return new Swiper(el, {
    slidesPerView: 2,
    spaceBetween: 60,
    autoHeight: true,
    navigation: {
      nextEl: `.${el.dataset.swiperControl} .swiper-btn.next`,
      prevEl: `.${el.dataset.swiperControl} .swiper-btn.prev`,
    },
    grid: {
      rows: 1,
      fill: 'row',
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 10,
        grid: undefined,
      },
      769: {
        slidesPerView: 2,
        spaceBetween: 60,
        grid: {
          rows: 1,
        },
      }
    },
    on: {
      activeIndexChange(s) {
        setTimeout(() => {
          let activeSlide = s.slides.find(el => el.classList.contains('swiper-slide-active'));
          $(activeSlide).find('.jci-bundle-item').click();
        }, 100);
      }
    }
  });
}

customElements.define('jci-bundler', JciBundler);


function initBundle(){

  const params = new URLSearchParams(window.location.search);
  const bundleKey = params.get("bundle") ?? null;
  const gender = params.get("gender") ?? null;

  if(!bundleKey || !gender){
    document.querySelector(`.jci-bundle-list`)?.classList?.remove("hidden");
    return;
  }

  document.querySelector(`.jci-bundle-list`)?.classList?.add("hidden");

  let jciBundler = document.querySelectorAll(`jci-bundler`);
  jciBundler.forEach((el) => {
    if(el.dataset.bundleKey==bundleKey && el.dataset.gender==gender){
      el.dataset.current = true;
    }
  })
}

initBundle();

